import React from "react";
import { useStyles } from "./styles";

export const StatisticWidgetRow = ({ children, ...props }) => {
  const ref = React.useRef<HTMLDivElement>(null);
  const classes = useStyles(props);

  return (
    <div className={classes.row} ref={ref}>
      {children}
    </div>
  );
};
StatisticWidgetRow.muiName = "StatisticWidgetRow";
StatisticWidgetRow.displayName = "StatisticWidgetRow";

export default StatisticWidgetRow;
